import {defineStore} from "pinia/dist/pinia";

export const useLoadingStore = defineStore('LoadingStore', {
    state() {
        return {
            interval: null,
            loadingState: 0,
            progressLoaded: 30,
            progressTotal: 0,
        }
    },
    getters: {
        loading() { return this.loadingState > 0 },
        progress() {
            let progress = Math.round((this.progressLoaded * 100) / this.progressTotal)
            if (progress > 99) {
                progress = 99
            }
            return progress
        },
    },
    actions: {
        startLoading() {
            this.loadingState = this.loadingState + 1
            this.startProgress()
        },
        startProgress() {
            if (this.progressLoaded < 70) {
                setTimeout(() => {
                    this.progressLoaded = 70
                }, 1000);
            }
            if (this.interval == null) {
                this.interval = setInterval(() => {
                    if (this.loadingState === 0) {
                        clearInterval(this.interval)
                        this.interval = null
                    } else {
                        this.incrementProgressLoaded(2)
                    }
                }, 500);
            }
        },
        stopLoading() {
            this.progressLoaded
            this.progressTotal = 100
            if (this.loadingState === 1) {
                clearInterval(this.interval)
                this.interval = null
                this.progressLoaded = 100
                setTimeout(() => {
                    this.loadingState = this.loadingState > 0 ? this.loadingState - 1 : 0
                    this.progressLoaded = 0
                }, 800);
            } else {
                this.loadingState = this.loadingState > 0 ? this.loadingState - 1 : 0
            }
        },
        resetLoading() {
            clearInterval(this.interval)
            this.interval = null
            this.loadingState = 0
            this.progressLoaded = 0
            this.progressTotal = 0
        },
        incrementProgressLoaded(param) {
            this.progressLoaded += (isNaN(this.progressLoaded) ? 0 : this.progressLoaded = this.progressLoaded + param);
        },
        incrementProgressTotal() {
            this.progressTotal += (isNaN(this.progressTotal) ? 0 : this.progressTotal);
        },
    }
})